//* IMPORT
//---------------------------------------------------------- */
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

/* Webフォント
---------------------------------------------------------- */
const webfont = () => {
	window.WebFontConfig = {
		google: {
			families: [
				'Noto+Sans+JP:400,500,700,900',
				'Noto+Serif+JP:500,600',
				'Montserrat:200,300,500,600,900',
				'Roboto+Condensed:700,900'
			],
		},
		active: () => {
			sessionStorage.fonts = true;
		},
	};
	(() => {
		let wf = document.createElement('script');
		wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
		wf.type = 'text/javascript';
		wf.async = 'true';
		let s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(wf, s);
	})();
};

/* グローバルナビ
---------------------------------------------------------- */
const gnavAction = () => {
	const body = document.body;
	const gnavOpenClass = 'is-nav-opened';
	const gnavCloseClass = 'is-nav-closed';
	const gnav = document.getElementById('gnav');

	window.addEventListener('touchmove', (e) => {
		if (body.classList.contains(gnavOpenClass) && e.target === gnav) {
			e.preventDefault();
		} else {
			e.stopPropagation();
		}
	}, { passive: false });

	if (body.classList.contains(gnavOpenClass)) {
		body.classList.remove(gnavOpenClass);
		body.classList.add(gnavCloseClass);
	} else {
		body.classList.remove(gnavCloseClass);
		body.classList.add(gnavOpenClass);
	}
};

const entryAction = () => {
	const body = document.body;
	const gnavOpenClass = 'is-entry-opened';
	const gnavCloseClass = 'is-entry-closed';

	window.addEventListener('touchmove', (e) => {
		if (body.classList.contains(gnavOpenClass)) {
			e.preventDefault();
		} else {
			e.stopPropagation();
		}
	}, { passive: false });

	if (body.classList.contains(gnavOpenClass)) {
		body.classList.remove(gnavOpenClass);
		body.classList.add(gnavCloseClass);
	} else {
		body.classList.remove(gnavCloseClass);
		body.classList.add(gnavOpenClass);
	}
};

const gnavToggle = () => {
	const gnavToggle = document.querySelectorAll('.js-gnav-toggle');
	const entryToggle = document.querySelectorAll('.js-entry-toggle');
	const overlay = document.getElementById('overlay');

	// ハンバーガーメニュークリック
	if (gnavToggle !== null) {
		Array.prototype.forEach.call(gnavToggle, (el) => {
			el.addEventListener('click', (e) => {
				gnavAction(e);
			});
		});
	}

	// エントリーボタンクリック
	if (entryToggle !== null) {
		Array.prototype.forEach.call(entryToggle, (el) => {
			el.addEventListener('click', (e) => {
				entryAction(e);
			});
		});
	}

	// 背景クリック
	if (overlay !== null) {
		overlay.addEventListener('click', (e) => {
			entryAction(e);
		});
	}

	window.addEventListener('load', (e) => {
		document.body.classList.add('is-nav-loaded');
	});
};

const gnavAccordion = () => {

	const nav = document.querySelectorAll('.js-nav-accordion');

	nav.forEach((el) => {

		const toggle  = el.querySelector(".js-nav-accordion__toggle");

		toggle.addEventListener("click", () => {
			el.classList.toggle('is-opened');
		})
	});

};

const disableScroll = (el) => {

	const body = document.body;
	const className = 'is-scroll-disabled';

	// el.scrollTop = 1;

	window.addEventListener('touchmove', (event) =>  {
		if( body.classList.contains(className) && event.target === el ){
			event.preventDefault();
		} else {
			event.stopPropagation();
		}
	},{ passive: false });

	// if( body.classList.contains(className) ){
	// 	body.classList.remove(className);
	// } else {
	// 	body.classList.add(className);
	// }

};

/* タブ
---------------------------------------------------------- */
const tab = () => {
	const tab = document.querySelectorAll('.js-tab');

	if (tab.length < 1) return false;

	const url = new URL(window.location.href);
	const params = url.searchParams;
	// const active = ( location.hash ) ? location.hash.replace('#', '') : 'sales';

	Array.prototype.forEach.call(tab, (el, i) => {
		const tab_head = el.querySelectorAll('.js-tab-head');
		const tab_head_child = tab_head[0].children;
		const tab_body = el.querySelectorAll('.js-tab-body');
		const tab_body_child = tab_body[0].children;

		tab_head_child[0].classList.add('is-active');
		tab_body_child[0].classList.add('is-active');

		for (let $i = 0; $i < tab_head_child.length; $i++) {

			// const tab_head_child_id = tab_body_child[$i].dataset.id;
			// const tab_body_child_id = tab_head_child[$i].dataset.id;

			// if ( tab_head_child_id === active ) {
			// 	tab_head_child[$i].classList.add('is-active');
			// } else {
			// 	tab_head_child[$i].classList.remove('is-active');
			// }

			// if ( tab_body_child_id === active ) {
			// 	tab_body_child[$i].classList.add('is-active');
			// } else {
			// 	tab_body_child[$i].classList.remove('is-active');
			// }

			let index = $i;

			tab_head_child[$i].addEventListener('click', () => {
				for (let $i = 0; $i < tab_head_child.length; $i++) {
					tab_body_child[$i].classList.remove('is-active');
					tab_head_child[$i].classList.remove('is-active');
				}

				tab_body_child[index].classList.add('is-active');
				tab_head_child[index].classList.add('is-active');
			});
		}
	});
};

window.addEventListener('hashchange', tab, false);

/* スクロール関連
---------------------------------------------------------- */
// const scroll = () => {

//   const body = document.body;
//   const scrolledClass = 'is-scrolled';

//   const scrolledAction = function() {

//     const windowYPos = window.pageYOffset;

// 		const scrollTop = Math.max(
// 			windowYPos,
// 			document.documentElement.scrollTop,
// 			document.body.scrollTop
// 		);

// 		// スクロール判定
// 		if (scrollTop > 100) {
// 			body.classList.add(scrolledClass);
// 		} else {
// 			body.classList.remove(scrolledClass);
// 		}

//   }

//   window.addEventListener('load', scrolledAction);
//   window.addEventListener('scroll', scrolledAction);
//   window.addEventListener('touchmove', scrolledAction);

// }

/* 要素のフェードイン
---------------------------------------------------------- */
const inView = () => {
	const items = document.querySelectorAll('.js-inview');
	const isInview = 'is-inview';

	if (items.length < 1) return false;

	const cb = (entries, observer) => {
		entries.forEach((entry) => {

			const toggle = entry.target.dataset.inviewToggle;

			// console.log(entry);

			if (entry.isIntersecting) {

				entry.target.classList.add(isInview);

			} else {

				if ( toggle ) {
					entry.target.classList.remove(isInview)
				}

			}

		});
	};

	const options = {
		root: null,
		rootMargin: '0px 0px 0px 0px',
		threshold: [0.1]
	};

	const io = new IntersectionObserver(cb, options);

	items.forEach((item) => {
		io.observe(item);
	});

	const transitionLast = document.querySelectorAll('.transition-last');
	transitionLast.forEach(el => {
		const parent = el.parentElement;
		const next = parent.dataset.next;
		const nextEl = document.querySelector(`.${next}`);

		el.addEventListener('transitionend', () => {
			el.parentElement.classList.add('is-transitionend');

			if ( parent.classList.contains('is-inview') ) {
				if ( !next || next === 'hero-cost' && !isPc() ) return false;
				nextEl.classList.add('is-inview');
			}
		});
	});
};

/* spanWrap
---------------------------------------------------------- */
const spanWrap = () => {

	const targets = document.querySelectorAll('.js-split-text');

	targets.forEach( target => {
		const nodes = [...target.childNodes];
		const inners = target.querySelectorAll('span');

		if ( inners ) {
			inners.forEach( inner => {
				const childNodes = [...inner.childNodes];
				spanWrapText(inner, childNodes);
			});
		}

		spanWrapText(target, nodes);

		const items = target.querySelectorAll('.s_t');
		const length = items.length;

		items.forEach( (item, i) => {
			const delay = ( target.dataset.delay ) ? i * target.dataset.delay : i * 0.1 ;
			item.style.transitionDelay = `${delay}s`;

			if ( i+1 == length ) {
				item.classList.add('s_t--last');
			}
		});

		const last = document.querySelectorAll('.s_t--last');
		last.forEach( el => {
			el.addEventListener('transitionend', () => {
				if ( target.classList.contains('is-inview') ) {
					target.classList.add('is-transitionend');
				}
			});
		});

	});

	function spanWrapText(target, nodes) {
		let spanWrapText = ""
		nodes.forEach((node, i) => {
			if (node.nodeType == 3) {//テキストの場合
				const text = node.textContent.replace(/\r?\n/g, '');//テキストから改行コード削除
				//spanで囲んで連結
				spanWrapText = spanWrapText + text.split('').reduce((acc, v) => {
					return acc + `<span class="s_t">${v}</span>`
				}, "");
			} else {//テキスト以外
				//<br>などテキスト以外の要素をそのまま連結
				spanWrapText = spanWrapText + node.outerHTML
			}
		});
		target.innerHTML = spanWrapText;
	}

}

/* アコーディオン
---------------------------------------------------------- */
const accordion = () => {

	const details = document.querySelectorAll(".js-details");
	const RUNNING_VALUE = "running";
	const IS_OPENED_CLASS = "is-opened";

	details.forEach((el) => {
		const summary = el.querySelector(".js-summary");
		const content = el.querySelector(".js-content");

		summary.addEventListener("click", (event) => {
			event.preventDefault();

			if (el.dataset.animStatus === RUNNING_VALUE) {
				return;
			}

			if (el.open) {

				el.classList.toggle(IS_OPENED_CLASS);

				const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
				el.dataset.animStatus = RUNNING_VALUE;

				closingAnim.onfinish = () => {
					el.removeAttribute("open");
					el.dataset.animStatus = "";
				};

			} else {

				el.setAttribute("open", "true");
				el.classList.toggle(IS_OPENED_CLASS);
				const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
				el.dataset.animStatus = RUNNING_VALUE;

				openingAnim.onfinish = () => {
					el.dataset.animStatus = "";
				};
			}
		});
	});

	const animTiming = {
		duration: 400,
		easing: "ease-out"
	};

	const closingAnimKeyframes = (content) => [
		{
			height: content.offsetHeight + 'px',
			// opacity: 1,
		}, {
			height: 0,
			// opacity: 0,
		}
	];

	const openingAnimKeyframes = (content) => [
		{
			height: 0,
			// opacity: 0,
		}, {
			height: content.offsetHeight + 'px',
			// opacity: 1,
		}
	];
}

/* parallaxText
---------------------------------------------------------- */
const parallaxText = () => {

	const bgText = document.querySelectorAll('.js-parallax-text, .bg-text__body');

	if ( bgText ) {

		bgText.forEach(el => {
			const width = el.scrollWidth;
			const reverse = el.dataset.parallaxReverse;
			const spOnly = el.dataset.parallaxSpOnly;
			const adjust = ( isPc() ) ? 100 : 0 ;
			const x = ( isPc() ) ? 50 :`-${width - window.innerWidth + adjust}px`;
			// const x = ( reverse ) ? `${width - window.innerWidth + adjust}px` : `-${width - window.innerWidth + adjust}px`;

			if ( spOnly === 'true' && isPc() ) return false;

			gsap.to(el, {
				x: x,
				scrollTrigger: {
					trigger: el,
					start: `top+=100 bottom`,
					end: "bottom top",
					scrub: 1,
					// markers: true,
				}
			});
		});

	}

}

/* hero
---------------------------------------------------------- */
const hero = () => {

	const hero = document.querySelector('.hero-01');

	if ( !hero ) return false;

	const heroLead = document.querySelector('.hero-01-lead');
	const transtionend = document.querySelector('.js-hero-01-transtionend');
	const delay = ( isPc() ) ? 0 : 1000

	gsap.to(heroLead, {
		scrollTrigger: {
			trigger: heroLead,
			endTrigger: 'html',
			start: `top bottom`,
			end: "bottom+=100 top",
			toggleClass: {targets: '.hero-01', className: 'scene−02'}
			// markers: true,
		}
	});

	const heroSliderStart = new Event('heroSliderStart');

	transtionend.addEventListener('transitionend', () => {
		setTimeout(() => {
			hero.classList.add('title-transtionend');
			window.dispatchEvent(heroSliderStart);
		}, delay);
	});

}

/* header
---------------------------------------------------------- */
const header = () => {

	gsap.to('.header', {
		scrollTrigger: {
			trigger: '.js-header-switch',
			endTrigger: 'html',
			start: `top top`,
			end: "bottom+=100 top",
			toggleClass: {targets: '.header', className: 'is-scrolled'},
			// markers: true,
		}
	});

}

/* cursorFollow
---------------------------------------------------------- */
const cursorFollow = () => {

	const ball = document.querySelector(".mouse");

	if ( !ball ) return false;

	const pointer = document.querySelector(".mouse__pointer");
	const containers = document.querySelectorAll(".js-hover-cursor");
	const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
	const mouse = { x: pos.x, y: pos.y };
	const speed = 0.2;
	const xSet = gsap.quickSetter(ball, "x", "px");
	const ySet = gsap.quickSetter(ball, "y", "px");

	gsap.set(".mouse", { xPercent: -60, yPercent: -60 });

	window.addEventListener("mousemove", (e) => {
		mouse.x = e.x;
		mouse.y = e.y;
	});
	gsap.ticker.add(() => {
		// adjust speed for higher refresh monitors
		const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
		pos.x += (mouse.x - pos.x) * dt;
		pos.y += (mouse.y - pos.y) * dt;
		xSet(pos.x);
		ySet(pos.y);
	});

	containers.forEach((container) => {
		container.addEventListener('mouseenter', (e) => {
			const bg = container.dataset.src;
			pointer.style.backgroundImage = `url(${bg})`
			ball.classList.add('is-hover')
		});
		container.addEventListener('mouseleave', (e) => {
			ball.classList.remove('is-hover')
			// pointer.style.backgroundImage = 'none'
		});
	});

}

/* slider
---------------------------------------------------------- */
const slider = () => {

	const hero = new Swiper('.hero-01-swiper', {
		effect: 'fade',
		loop: true,
		slidesPerView: 1,
		speed: 3000,
		allowTouchMove: false,
		// autoplay: {
		// 	delay: 2000,
		// },
		pagination: {
			el: `.swiper-pagination`,
		},
	});

	window.addEventListener('heroSliderStart', function(e) {
		hero.autoplay.start();
	});

	const hero2 = new Swiper('.hero-02-swiper', {
		loop: true,
		slidesPerView: 1.2,
		spaceBetween: 10,
		centeredSlides: true,
		speed: 20000,
		allowTouchMove: false,
		autoplay: {
			delay: 0,
		},
		breakpoints: {
			768: {
				slidesPerView: 1.5,
				spaceBetween: 20,
			},
		}
	});

	const otherInterview = document.querySelectorAll('.other-interview-swiper');

	otherInterview.forEach((el, i) => {
		const otherInterview = new Swiper(el, {
			slidesPerView: 1.6,
			spaceBetween: 10,
			navigation: {
				nextEl: `.slider-nav-button-next--${i}`,
				prevEl: `.slider-nav-button-prev--${i}`,
			},
			breakpoints: {
				768: {
					slidesPerView: 2.45,
					spaceBetween: 30,
				},
			}
		});
	});

	const businessFlow = document.querySelectorAll('.business-flow-swiper');

	businessFlow.forEach((el, i) => {
		const businessFlow = new Swiper(el, {
			slidesPerView: 1,
			navigation: {
				nextEl: `.swiper-button-next--${i}`,
				prevEl: `.swiper-button-prev--${i}`,
			},
			pagination: {
				el: `.swiper-pagination--${i}`,
			},
		});
	});

	const work = new Swiper('.work-section-swiper', {
		slidesPerView: 1.53,
		spaceBetween: 20,
		navigation: {
			nextEl: `.slider-nav-button-next`,
			prevEl: `.slider-nav-button-prev`,
		},
		scrollbar: {
			el: '.slider-nav-scrollbar',
			draggable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 1.54,
				spaceBetween: 47,
			},
		}
	});

	const environment = new Swiper('.environment-section-swiper', {
		loop: true,
		slidesPerView: 1.38,
		spaceBetween: 4,
		centeredSlides: true,
		speed: 20000,
		allowTouchMove: false,
		autoplay: {
			delay: 0,
		},
		breakpoints: {
			768: {
				slidesPerView: 2.62,
				spaceBetween: 8,
			},
		}
	});

}

/* scrollable
---------------------------------------------------------- */
import ScrollHint from 'scroll-hint'
import 'scroll-hint/css/scroll-hint.css';
const scrollable = () => {
	new ScrollHint('.js-scrollable', {
		i18n: {
			scrollable: 'スクロールできます',
		}
	});

}

/* setFillHeight
---------------------------------------------------------- */
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

let vw = window.innerWidth;

window.addEventListener('resize', () => {
  if (vw === window.innerWidth) {
  // 画面の横幅にサイズ変動がないので処理を終える
    return;
  }

  // 画面の横幅のサイズ変動があった時のみ高さを再計算する
  vw = window.innerWidth;
  setFillHeight();
});

/* resizeEnd
---------------------------------------------------------- */
const event = new CustomEvent('resizeend');
const currentWidth = window.innerWidth;
let timeoutID = 0;
let delay = 500;

window.addEventListener("resize", () => {

	if ( currentWidth === window.innerWidth ) return false;

	clearTimeout(timeoutID);
	timeoutID = setTimeout( () => {
		window.dispatchEvent(event);
	}, delay);

}, false);

/* mediaQuery
---------------------------------------------------------- */
const isPc = () => {

	const mq = ( window.matchMedia( "(min-width: 768px)" ).matches ) ? true : false;
	return mq;

}

/* Init
---------------------------------------------------------- */
webfont();
gnavToggle();
gnavAccordion();
tab();
// scroll();
disableScroll();
inView();
spanWrap();
accordion();
parallaxText();
hero();
header();
cursorFollow();
slider();
scrollable();
setFillHeight();